import PropTypes from 'prop-types'
import { Fragment } from 'react'
import { Helmet } from 'react-helmet'

import { InfraAttackContents } from 'components/attacks/details/InfraAttackContents'
import AttacksLayout from 'components/layouts/AttacksLayout'
import Header, {
  HeaderLink,
  HeaderRightChevron,
  Heading
} from 'components/navigation/Header'

export default function InfraAttackDetailsPage({ match, location }) {
  const { state: locationState = {} } = location
  const { infraAttack: attackFromLocationState } = locationState

  return (
    <Fragment>
      <Helmet title="Attack Details" />
      <Header>
        <HeaderLink to="/attacks">Attacks</HeaderLink>
        <HeaderRightChevron />
        <Heading>Attack Details</Heading>
      </Header>
      <AttacksLayout hideSubnav>
        <InfraAttackContents
          displayFirstAttackModal
          attackId={match.params.id}
          attackMetricsGraphProps={{
            // Remove margin on details pages
            css: {
              margin: 0
            }
          }}
          referenceAttack={attackFromLocationState}
        />
      </AttacksLayout>
    </Fragment>
  )
}

InfraAttackDetailsPage.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object
}
